module.exports = __webpack_public_path__ + "app-static/img/ex-3.b7d2eaf1.png";